<template>
  <div class="shareDetails_index_item">
    <li class="box">
      <div>排名</div>
      <div>店铺</div>
      <div>分享点击客户数</div>
      <div>成交金额</div>
    </li>
    <ul>
      <li class="box_item">
        <div>1</div>
        <div class="o van-ellipsis">大梅沙</div>
        <div>11人</div>
        <div>22223元</div>
      </li>
      <li class="box_item">
        <div>1</div>
        <div class="o van-ellipsis">大梅沙</div>
        <div>11人</div>
        <div>22223元</div>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  
}
</script>
<style lang="less" scoped>
  .shareDetails_index_item{
    background: #fff;
    height: 1109px;
    border-radius: 20px;
    padding: 40px 30px;
    font-size: 22px;
    color: #666;
    .box{
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 65px;
      font-size: 20px;
      background: #f7f7f7;
      div{
        flex: 1;
        text-align: center;
      }
    }
    .box_item{
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 65px;
      border-bottom: 1px solid #eee;
      div{
        flex: 1;
        text-align: center;
      }
    }
    .o{
      color: #F8A651;
    }
  }
</style>